// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"c7e0b054b2d0cfb4","4001":"bcb310696a91cd8e","8289":"67f0546a14c03f91"}[chunkId] + ".css";
};